// Home Page
export const HOME_ROUTE = '/';

//  Auth Routes names
export const LOGIN_ROUTE = '/login';
export const REGISTER_ROUTE = '/register';

//  Store Owner Route Names
const storeOwner = '/store-owner';
export const STORE_OWNER_DASHBOARD_ROUTE = `${storeOwner}/dashboard`;
export const STORE_OWNER_STORE_ROUTE = `${storeOwner}/store`;
export const STORE_OWNER_SALE_MANAGERS_ROUTE = `${storeOwner}/sale-managers`;
export const STORE_OWNER_EDIT_SALE_MANAGER_ROUTE = `${storeOwner}/edit-sale-manager`;
export const STORE_OWNER_ADD_SALE_MANAGER_ROUTE = `${storeOwner}/add-sale-manager`;
export const STORE_OWNER_VIEW_SALE_MANAGER_ROUTE = `${storeOwner}/view-sale-manager`;
export const STORE_OWNER_CHATS_ROUTE = `${storeOwner}/chats`;
export const STORE_OWNER_PRODUCTS_ROUTE = `${storeOwner}/products`;
export const STORE_OWNER_SALES_ROUTE = `${storeOwner}/sales`;
export const STORE_OWNER_LIVE_SALES_ROUTE = `${storeOwner}/live-sales`;
export const STORE_OWNER_ADD_PRODUCT_ROUTE = `${storeOwner}/add-product`;
export const STORE_OWNER_EDIT_PRODUCT_ROUTE = `${storeOwner}/edit-product`;
export const STORE_OWNER_VIEW_PRODUCT_ROUTE = `${storeOwner}/view-product`;
export const STORE_OWNER_PROFILE_ROUTE = `${storeOwner}/profile`;
export const STORE_OWNER_EDIT_PROFILE_ROUTE = `${storeOwner}/edit-profile`;

//  Sale Manager Route Names
const saleManager = '/sale-manager';
export const SALE_MANAGER_DASHBOARD_ROUTE = `${saleManager}/dashboard`;
export const SALE_MANAGER_PROFILE_ROUTE = `${saleManager}/profile`;
export const SALE_MANAGER_EDIT_PROFILE_ROUTE = `${saleManager}/edit-profile`;
export const SALE_MANAGER_CHATS_ROUTE = `${saleManager}/chats`;
export const SALE_MANAGER_PRODUCTS_ROUTE = `${saleManager}/products`;
export const SALE_MANAGER_VIEW_PRODUCT_ROUTE = `${saleManager}/view-product`;
export const SALE_MANAGER_SALES_ROUTE = `${saleManager}/sales`;
export const SALE_MANAGER_LIVE_SALES_ROUTE = `${saleManager}/today-sales`;
export const SALE_MANAGER_ADD_SALE_ROUTE = `${saleManager}/add-sale`;
